
import { Button } from "element-ui";
import { InfoIcon } from "vue-feather-icons";
import { PaymentHelper } from "@/helpers/PaymentHelper";

export default {
  data() {
    return {
      sofortInstance: null,
      hipay: null,
      errors: [],
    };
  },
  computed: {
    defaultLocal() {
      return this.$i18n.locale;
    },
  },
  mounted() {
    try {
      this.initHipay();
      this.sofortPayment();
    } catch (error) {}
  },
  methods: {
    initHipay() {
      this.hipay = HiPay({
        username: process.env.HIPAY_USERNAME,
        password: process.env.HIPAY_PASSWORD,
        environment: process.env.HIPAY_ENVIRONMENT,
        lang: this.defaultLocal,
      });
    },
    sofortPayment() {
      const option = {
        selector: "hipay-sofort",
        template: "auto",
      };
      if (this.hipay != null) {
        this.sofortInstance = this.hipay.create("sofort-uberweisung", option);
      }
    },
  },
  components: { Button, InfoIcon },
};
